import Angular from "angular";
import Loader from "angular-ecmascript/module-loader";
import {Service} from "angular-ecmascript/module-helpers";
import Filter from "../model/filter.model";
import WheelStorage from "../model/wheelstorage.model";
import Settings from "../providers/settings.provider";

export var Name = 'WheelStorages';

export class WheelStoragesFilter extends Filter {

    static load = function (name) {
        return Filter.load(name, WheelStoragesFilter);
    };

    constructor(data) {
        super(data);

        this.sortBy = 'storageNumber';
        this.search = null;
        this.active = null;
        this.behindTime = null;
        this.rimState = null;
        this.tyreState = null;
        this.status = null;
        this.type = null;
        this.maxProfileDepth = null;
        this.minAge = null;
        this.storageId = null;
        this.branchId = null;
        this.customerId = null;
        this.vehicleId = null;

        if (data) {
            Object.assign(this, data);
        }
    }

    active() {
        if (this.search != null
            || this.active != null
            || this.behindTime != null
            || this.rimState != null
            || this.tyreState != null
            || this.status != null
            || this.type != null
            || this.maxProfileDepth != null
            || this.minAge != null
            || this.storageId != null
            || this.branchId != null
            || this.customerId != null
            || this.vehicleId != null) {

            return true;
        }

        return false;
    }

    reset() {
        super.reset();
        this.sortBy = 'storageNumber';
        this.search = null;
        this.active = null;
        this.behindTime = null;
        this.rimState = null;
        this.tyreState = null;
        this.status = null;
        this.type = null;
        this.maxProfileDepth = null;
        this.minAge = null;
        this.storageId = null;
        this.branchId = null;
        this.customerId = null;
        this.vehicleId = null;
    }

}

export class WheelStorages extends Service {
    static $name = Name;
    static $inject = ['$q', 'Restangular', 'settings'];

    static State = {
        UNKNOWN: "UNKNOWN",
        OKAY: "OKAY",
        MARGINAL: "MARGINAL",
        RISKY: "RISKY"
    };

    static Status = {
        CHECK: "CHECK",
        INWORK: "INWORK",
        DONE: "DONE"
    };

    static Type = {
        SUMMER: "SUMMER",
        WINTER: "WINTER",
        ALLSEASON: "ALLSEASON"
    };

    create() {
        // NOOP.
    }

    get(storageId) {
        var defer = this.$q.defer();

        this.Restangular
            .setBaseUrl(this.settings.httpUrl('app'))
            .one('storage', storageId)
            .get()
            .then((storageData) => {
                defer.resolve(this.Restangular.copy(new WheelStorage(storageData)));
            })
            .catch((err) => {
                defer.reject(err);
            });

        return defer.promise;
    }

    find(wheelStoragesFilter) {
        var defer = this.$q.defer();

        this.Restangular
            .setBaseUrl(this.settings.httpUrl('app'))
            .all('storages')
            .post(wheelStoragesFilter)
            .then((response) => {
                response.data = response.data.map((storageData) => {
                    return this.Restangular.copy(new WheelStorage(storageData));
                });

                defer.resolve(response);
            })
            .catch((err) => {
                defer.reject(err);
            });

        return defer.promise
    }

}

var WheelStoragesModule = Angular.module('wheelstorages-service', ['restangular', Settings.name]);

new Loader(WheelStoragesModule)
    .load(WheelStorages);

export default WheelStoragesModule;



// WEBPACK FOOTER //
// ./src/modules/main/services/wheelstorages.service.js